import api from "../../lib/api";
import ArticlePage from "../../components/Article/ArticlePage";
import { useEffect } from "react";
import { useRouter } from "next/router";

export default function Index({ projectPages }) {
  const router = useRouter();
  const baseRoute = "project";

  useEffect(() => {
    router.replace(`/${baseRoute}/${projectPages[0].slug}`);
  }, []);

  return <ArticlePage navData={projectPages} baseRoute={baseRoute} />;
}

export async function getStaticProps({ locale }) {
  const projectPages = await api.getProjectPages(locale);

  return await api.injectDefaultData(
    {
      props: { projectPages },
      revalidate: 3,
    },
    locale,
  );
}
